import { render, staticRenderFns } from "./TheSignatureConfirmation.vue?vue&type=template&id=2c5fcb11&scoped=true&"
import script from "./TheSignatureConfirmation.vue?vue&type=script&lang=js&"
export * from "./TheSignatureConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./TheSignatureConfirmation.vue?vue&type=style&index=0&id=2c5fcb11&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5fcb11",
  null
  
)

export default component.exports